/**
 * Service Locations Map - Shared utility for location label mapping
 * Used across BasicInfoStep, MyAgentProfile, ViewAgentProfile
 */

export const SERVICE_LOCATIONS_MAP = {
    // Metro Cities
    mumbai_mh: 'Mumbai',
    delhi_ncr: 'Delhi NCR',
    bangalore_ka: 'Bangalore',
    hyderabad_tg: 'Hyderabad',
    chennai_tn: 'Chennai',
    kolkata_wb: 'Kolkata',
    pune_mh: 'Pune',

    // Tier 1 Cities
    ahmedabad_gj: 'Ahmedabad',
    surat_gj: 'Surat',
    jaipur_rj: 'Jaipur',
    lucknow_up: 'Lucknow',
    kanpur_up: 'Kanpur',
    nagpur_mh: 'Nagpur',
    indore_mp: 'Indore',
    thane_mh: 'Thane',
    bhopal_mp: 'Bhopal',
    visakhapatnam_ap: 'Visakhapatnam',
    patna_br: 'Patna',
    vadodara_gj: 'Vadodara',
    ghaziabad_up: 'Ghaziabad',
    ludhiana_pb: 'Ludhiana',
    agra_up: 'Agra',
    nashik_mh: 'Nashik',
    coimbatore_tn: 'Coimbatore',
    kochi_kl: 'Kochi',

    // State-wide options
    state_maharashtra: 'All Maharashtra',
    state_gujarat: 'All Gujarat',
    state_karnataka: 'All Karnataka',
    state_tamilnadu: 'All Tamil Nadu',
    state_telangana: 'All Telangana',
    state_andhrapradesh: 'All Andhra Pradesh',
    state_uttarpradesh: 'All Uttar Pradesh',
    state_westbengal: 'All West Bengal',
    state_rajasthan: 'All Rajasthan',
    state_madhyapradesh: 'All Madhya Pradesh',
    state_punjab: 'All Punjab',
    state_kerala: 'All Kerala',

    // National
    all_india: 'Pan-India',
};

/**
 * Get the display label for a service area code
 * @param {string} areaCode - The coded value (e.g., 'mumbai_mh')
 * @returns {string} Human-readable label (e.g., 'Mumbai')
 */
export const getLocationLabel = (areaCode) => {
    return SERVICE_LOCATIONS_MAP[areaCode] || areaCode;
};

/**
 * Get the icon for a service area based on its type
 * @param {string} areaCode - The coded value
 * @returns {string} PrimeIcon class name
 */
export const getLocationIcon = (areaCode) => {
    if (areaCode === 'all_india') return 'pi pi-globe';
    if (areaCode?.startsWith('state_')) return 'pi pi-globe';
    return 'pi pi-map-marker';
};
